import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  retailerTypeFeatureKey,
  RetailerTypeState,
} from './retailer-type-reducer';

export const getFilterRetailerTypeState =
  createFeatureSelector<RetailerTypeState>(retailerTypeFeatureKey);

export const getRetailerTypeState = createSelector(
  getFilterRetailerTypeState,
  (state: RetailerTypeState) => state
);
